/** Storage contract (subset of Web Storage). Injected to keep this pure. */
interface StorageLike {
  getItem(k: string): string | null;
  setItem(k: string, v: string): void;
  removeItem(k: string): void;
}

export interface AudioSettings {
  muted: boolean;
  volume: number;
  musicEnabled: boolean;
}

const KEY = 'hambi.audio';
const DEFAULTS: AudioSettings = { muted: false, volume: 0.8, musicEnabled: true };

/** Persists the player's mute + master-volume preferences under `hambi.audio`. */
export class AudioSettingsService {
  constructor(private readonly storage: StorageLike) {}

  get(): AudioSettings {
    const raw = this.storage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    try {
      const p = JSON.parse(raw) as Partial<AudioSettings>;
      return {
        muted: typeof p.muted === 'boolean' ? p.muted : DEFAULTS.muted,
        volume:
          typeof p.volume === 'number' && p.volume >= 0 && p.volume <= 1
            ? p.volume
            : DEFAULTS.volume,
        musicEnabled: typeof p.musicEnabled === 'boolean' ? p.musicEnabled : DEFAULTS.musicEnabled,
      };
    } catch {
      return { ...DEFAULTS };
    }
  }

  setMuted(muted: boolean): void {
    this.write({ ...this.get(), muted });
  }

  setVolume(volume: number): void {
    this.write({ ...this.get(), volume: Math.max(0, Math.min(1, volume)) });
  }

  setMusicEnabled(musicEnabled: boolean): void {
    this.write({ ...this.get(), musicEnabled });
  }

  private write(s: AudioSettings): void {
    this.storage.setItem(KEY, JSON.stringify(s));
  }
}
